/* Copyright (c) 2017 Backpack Health LLC */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

class DownloadProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ellipses: 1,
      opacity: 100,
    };
  }

  componentDidMount() {
    this.animationInterval = setInterval(this.animateEllipsis.bind(this), 500);
  }

  componentWillUnmount() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  }

  animationInterval;
  animationTimeout;
  animateEllipsis() {
    this.setState(state => ({
      ellipses: state.ellipses >= 3 ? 0 : state.ellipses + 1,
    }));
  }

  render() {
    const props = this.props;
    const renderEllipsis = current => {
      const span = key => (
        <span key={key} style={{ opacity: 0 }}>
          .
        </span>
      );
      const ellipses = [span(0), span(1), span(2)];
      for (let i = 0; i < current; i++) {
        ellipses[i] = (
          <span key={i} style={{ opacity: 1 }}>
            .
          </span>
        );
      }
      return ellipses;
    };
    const renderContent = () => {
      if (props.isVisible) {
        return (
          <div>
            {props.isDownloading ? (
              <span>
                <FormattedMessage id="download.progressAndroid.message.text" />
                {renderEllipsis(this.state.ellipses)}
              </span>
            ) : null}
            {props.isDone ? (
              <div className={'animate'}>
                <FormattedMessage id="download.confirmAndroid.message.text" />
              </div>
            ) : null}
            {props.isError ? (
              <div className={'animate'}>
                <FormattedMessage id="error.downloadAndroid.message" />
              </div>
            ) : null}
          </div>
        );
      }
      return null;
    };
    return <div className="cmp-file-progress" style={this.props.styles}>{renderContent()}</div>;
  }
}

DownloadProgress.propTypes = {
  isVisible: PropTypes.bool,
  isDownloading: PropTypes.bool,
  isDone: PropTypes.bool,
  isError: PropTypes.bool,
  styles: PropTypes.object,
};

export default DownloadProgress;
